import './Menu.css'
import { useRef, FC, useContext, useState } from "react";
import { Menu, Button, Flex, MenuRef } from 'antd';
import { ResponsiveContext } from '../../../context/responsive-context';
import { MenuOutlined } from '@ant-design/icons'
import { MenuProps } from 'antd/lib';
import { useOnClickOutside } from 'usehooks-ts';
import { MenuButton, TransparentButton } from '../../../common-components/CustomButtons';

export const MenuComponent: FC = () => {
  const { isMobile } = useContext(ResponsiveContext)
  const [collapsed, setCollapsed] = useState(true);
  const menuRef = useRef<HTMLDivElement>(null!)

  useOnClickOutside(menuRef, () => setCollapsed(true))

  const toggleCollapsed = () => {
    if (collapsed) {
      setCollapsed(false);
    }
  };

  type MenuItem = Required<MenuProps>['items'][number];

  const scrollToElement = (id: string) => {
    const element = document.getElementById(id);
    element?.scrollIntoView({
      behavior: 'smooth'
    })
    setCollapsed(true)
  }

  const scrollToColor = () => scrollToElement('color')
  const scrollToBody = () => scrollToElement('body')
  const scrollToOther = () => scrollToElement('other')
  const scrollToContact = () => scrollToElement('map')
  const scrollToGift = () => scrollToElement('gift')
  const scrollToCompany = () => scrollToElement('company')
  const scrollToBook = () => scrollToElement('book')
  const scrollToAboutLanding = () => scrollToElement('aboutlanding')

  const itemDefinitions = [
    { title: 'SZÍNTANÁCSADÁS', onClick: scrollToColor },
    { title: 'TESTALKAT TANÁCSADÁS', onClick: scrollToBody },
    { title: 'EGYÉB SZOLGÁLTATÁSOK', onClick: scrollToOther },
    { title: 'HELYSZÍNEK', onClick: scrollToContact },
    { title: 'AJÁNDÉKKÁRTYA', onClick: scrollToGift },
    { title: 'CÉGEKNEK', onClick: scrollToCompany },
    { title: 'ÜZENET', onClick: scrollToBook },
    { title: 'RÓLAM', onClick: scrollToAboutLanding },
  ]

  const items: MenuItem[] = itemDefinitions.map((item, index) =>
   ({ key: (index + 1).toString(), label: <div className="Menu-item" style={{ opacity: '100%', fontWeight: 'bold' }}>{item.title}</div>, onClick: item.onClick }
                                               ))


  return (
    <>
    { isMobile &&
      <Flex vertical className="Hamburger" justify={'end'} align={'end'}>
      <TransparentButton
      onClick={toggleCollapsed}
      style={{ marginBottom: 16, width: 40}}>
        <MenuOutlined />
        </TransparentButton>
      { !collapsed &&
      <div ref={menuRef} style={{ zIndex: 99 }}>
        <Menu
        items={items}
        theme={"dark"}
        />
      </div>
      }

      </Flex>
    }
    { !isMobile &&
    <Flex className="Menu" style={{ height: '100%' }} vertical justify={'space-evenly'} align={'center'}>
      {itemDefinitions.map(item => {
        return (
          <MenuButton onClick={item.onClick}>{item.title}</MenuButton>
        )
      })}
    </Flex>
    }
    </>
  )
}
